var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactAgentCtrl = function () {
    function ContactAgentCtrl($stateParams, $state) {
        _classCallCheck(this, ContactAgentCtrl);

        this.stateParams = $stateParams;
        this.state = $state;
        this.claimNumber = this.stateParams.claimNumber;
    }

    _createClass(ContactAgentCtrl, [{
        key: 'goBackToHomeState',
        value: function goBackToHomeState() {
            var _stateParams$returnSt = _slicedToArray(this.stateParams.returnStateInfo, 2),
                returnState = _stateParams$returnSt[0],
                params = _stateParams$returnSt[1];

            this.state.go(returnState, params);
        }
    }]);

    return ContactAgentCtrl;
}();

ContactAgentCtrl.$inject = ['$stateParams', '$state'];
export default ContactAgentCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/common/components/ContactAgent/ContactAgentCtrl.js
// module id = 1509
// module chunks = 0